'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable no-underscore-dangle */
var SessionService = function () {
  function SessionService(localStorageService) {
    'ngInject';

    _classCallCheck(this, SessionService);

    this.localStorageService = localStorageService;

    this._user = JSON.parse(localStorageService.get('session.user'));
    this._authToken = localStorageService.get('session.authToken');
    this._reportParams = JSON.parse(localStorageService.get('session.reportParams'));
  }

  _createClass(SessionService, [{
    key: 'destroy',
    value: function destroy() {
      this.user = null;
      this.authToken = null;
    }
  }, {
    key: 'user',
    get: function get() {
      return this._user;
    },
    set: function set(user) {
      this._user = user;
      this.localStorageService.set('session.user', JSON.stringify(user));
    }
  }, {
    key: 'reportParams',
    get: function get() {
      return this._reportParams;
    },
    set: function set(params) {
      this._reportParams = params;
      this.localStorageService.set('session.reportParams', JSON.stringify(params));
    }
  }, {
    key: 'authToken',
    get: function get() {
      return this._authToken;
    },
    set: function set(token) {
      this._authToken = token;
      this.localStorageService.set('session.authToken', token);
    }
  }]);

  return SessionService;
}();

exports.default = SessionService;


// WEBPACK FOOTER //
// ./services/session.service.js